<template>

  <div class="cc-4-l widget-simple-text">

    <!-- If loading -->
    <div class="cc-loader " v-if="loading">
      <div class="spinner"></div>
    </div>

    <!-- else -->
    <div v-else>
      <div v-if="!errored" class="cc-fs-25">
        <div class="container">
          <div class="gauge-bg"></div>
          <div class="gauge-middle"></div>
          <div class="gauge-overlay" :style="{ transform: rotate }"></div>
          <p class="gauge-data">
            <i class="fal fa-2x fa-piggy-bank icon-left" aria-hidden></i>
            {{ percentage }}%
          </p>
        </div>
      </div>
      <div v-else>
        <i class="fas fa-spider-black-widow icon-left" aria-hidden></i>
        LightHouse down ?
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

const api = 'https://api.alpixel.fr/compta/ca/annuel'

export default {
  name: 'Compta',
  components: {},
  data() {
    return {
      percentage: 0,
      errored: false,
      loading: true,
    }
  },
  computed: {
    rotate() {
      const v = this.percentage * 180 / 100
      return `rotate(${v}deg)`
    }
  },
  mounted() {
    axios
        .get(api)
        .then(response => {
          // this.percentage = Math.round(parseFloat(response.data.data) / 120000 * 100);
          let total = parseFloat(response.data.data);

          total = total - 1120; //virginie straton

          //Plutot 55 000 quand on aura vendu le local
          //Plutot 75 000 quand on l'a pas vendu
          this.percentage = Math.round(total / 75000 * 100);
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.loading = false
        })
  },
}
</script>


<style scoped lang="less">
body {
  background-color: #4d4d4d;
}

@gauge-width: 400px;
@gauge-heigth: @gauge-width / 2;
@gauge-bar-width: 75px;
@middle-width: @gauge-width - (@gauge-bar-width * 2);

@gauge-color: #81AC40;
@gauge-bg-color: lighten(@gauge-color, 15%);

.container {
  width: @gauge-width;
  height: @gauge-heigth;
  position: relative;
  overflow: hidden;
}

.gauge-bg {
  z-index: 1;
  width: @gauge-width;
  height: @gauge-heigth;
  position: absolute;
  background-color: @gauge-bg-color;
  border-radius: @middle-width @middle-width 0 0;
}

.gauge-middle {
  z-index: 3;
  position: absolute;
  background-color: #333;
  width: @middle-width;
  height: calc(@middle-width / 2);
  top: @gauge-bar-width;
  margin-left: @gauge-bar-width;
  margin-right: auto;
  border-radius: @middle-width @middle-width 0 0;
}

.gauge-overlay {
  z-index: 2;
  position: absolute;
  background-color: @gauge-color;
  width: @gauge-width;
  height: @gauge-heigth;
  top: @gauge-heigth;
  border-radius: 0 0 @gauge-heigth @gauge-heigth;
  transform-origin: center top;
}

.gauge-data {
  z-index: 4;
  color: #fff;
  position: absolute;
  width: @gauge-width;
  bottom: 0;
  font-weight: bold;
  font-size: 26pt;
}

</style>
